/*
  The dashboard routes the wizard links to. The old modules write these paths inline (there is no
  shared route helper to import), so they are gathered here, each as its module writes it:
  - campaign builder: `CampaignListTable` duplicate, and the Common Campaign Fields FR's
    "/p/campaigns/create/info";
  - campaign show / edit / pending request: `CampaignListTable` `getRedirectPath` and edit actions;
  - reward builder: `pages/reward/list.tsx` "Create reward";
  - loyalty builder: `Loyalty/pages/LoyaltyListPage.tsx` "Create";
  - rule / reward / audience show and create: `RuleOutcomesTable`, `RewardListTable`,
    `AudienceListPage`.
*/
export const wizardLinks = {
  createCampaign: () => '/p/campaigns/create/info',
  showCampaign: (id: number | string) => `/p/campaigns/show/${id}`,
  editCampaign: (id: number | string) => `/p/campaigns/edit/${id}`,
  campaignRequest: (id: number | string, requestId: number | string) =>
    `/p/campaigns/show/${id}/campaign_request/${requestId}`,
  createReward: () => '/p/rewards/create/info',
  createLoyalty: () => '/p/loyalty/create',
  showRule: (id: number | string) => `/p/rules/show/${id}`,
  showReward: (id: number | string) => `/p/rewards/show/${id}`,
  showAudience: (id: number | string) => `/p/audiences/show/${id}`,
  ruleRequest: (id: number | string, requestId: number | string) =>
    `/p/rules/show/${id}/rule_request/${requestId}`,
  rewardRequest: (id: number | string, requestId: number | string) =>
    `/p/rewards/show/${id}/reward_request/${requestId}`,
  createRule: () => '/p/rules/create',
  createAudience: () => '/p/audiences/create'
};
